import React from "react";
 

/**
 * App store-style row: rounded square icon, title + chevron (primary), description.
 */
const AppStoreMenuItem = ({ title, description, iconClassName, iconChildren, link }) => (
    <div className="flex items-start gap-3">
        <div
            className={`flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-lg ${iconClassName}`}
        >
            {iconChildren}
        </div>
        <div className="min-w-0 flex-1 pt-0.5">
            <div className="flex items-center gap-0.5 text-sm font-medium ">
                <a href={link} target="_blank" rel="noopener noreferrer">{title}</a>
            </div>
            <p className="mt-0.5 text-left text-xs leading-relaxed text-[#5c6370]">{description}</p>
        </div>
    </div>
);

export default AppStoreMenuItem;
